import { LoadingPlaceholderIcon } from '@liveoptics/react-ui';
import React, {FC, useContext} from 'react';
import { AppContext } from './components/AppContextProvider';
import Main from './views/Main'
import Loading from './views/Loading'

const Viewer: FC = () => {
    const {config} = useContext(AppContext)
    if (config) {
        return <Main config={config}></Main>
    }
    return <Loading />;
 }
export default Viewer

